import styled from "styled-components";

export const ChatbotImgReaderCase = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
  }
`;
